import type { CityTimeSnapshot } from '../time/cityTime';

/** Strike only an hour reached naturally. Entry, scrubbing and missed hours stay silent. */
export class BellClock {
  private previous: CityTimeSnapshot | null = null;

  reset(): void {
    this.previous = null;
  }

  update(time: CityTimeSnapshot): { strikes: number; reset: boolean } {
    const before = this.previous;
    this.previous = time;
    if (!before) return { strikes: 0, reset: false };
    const elapsed = ((time.minutes - before.minutes + 2160) % 1440) - 720;
    const reset = time.revision !== before.revision || elapsed < 0 || elapsed > 1;
    const hour = Math.floor(time.minutes / 60);
    return {
      strikes: !reset && hour !== Math.floor(before.minutes / 60) ? hour % 12 || 12 : 0,
      reset,
    };
  }
}
